import { render, staticRenderFns } from "./staff-edit.vue?vue&type=template&id=70a05e55&scoped=true&"
import script from "./staff-edit.vue?vue&type=script&lang=js&"
export * from "./staff-edit.vue?vue&type=script&lang=js&"
import style0 from "./staff-edit.vue?vue&type=style&index=0&id=70a05e55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a05e55",
  null
  
)

export default component.exports